var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFillPhone = function SvgFillPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "current",
    height: "current",
    viewBox: "0 0 12 12"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.633 8.82-.313 2.153a.831.831 0 0 1-.82.714h-.02a10.324 10.324 0 0 1-4.093-.967 10.37 10.37 0 0 1-2.98-2.087 10.542 10.542 0 0 1-2.087-2.98C.72 4.367.393 2.993.353 1.567A.836.836 0 0 1 1.067.72L3.227.4c.42-.06.82.2.926.607l.774 2.886a.842.842 0 0 1-.487.987l-.48.2a7.826 7.826 0 0 0 2.98 3.06l.22-.533a.835.835 0 0 1 .987-.487l2.886.773a.827.827 0 0 1 .607.927h-.007Z",
    fill: "#2E3134"
  })));
};
export default SvgFillPhone;